import React, { Component } from "react";
import { Icon } from "@iconify/react";
import reactIcon from "@iconify/icons-logos/react";
import java from "@iconify/icons-logos/java";
import aws from "@iconify/icons-logos/aws";

class About extends Component {
  render() {
    const profilepic = this.props.sharedBasicInfo?.image;
    const sectionName = this.props.resumeBasicInfo?.section_name?.about;
    const hello = this.props.resumeBasicInfo?.description_header || "Hey";
    const aboutRaw = this.props.resumeBasicInfo?.description || "";
    const paragraphs = String(aboutRaw).split(/\n\s*\n/);

    return (
      <section id="about">
        <div className="col-md-12">
          <h1 style={{ color: "black" }}>
            <span>{sectionName}</span>
          </h1>
          <div className="row center mx-auto mb-5">
            <div className="col-md-4 mb-5 center">
              <div className="polaroid">
                <span style={{ cursor: "auto" }}>
                  <img
                    height="250px"
                    src={process.env.PUBLIC_URL + `${profilepic}`}
                    alt="Avatar placeholder"
                  />
                  <Icon
                      icon={reactIcon}
                      style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                      icon={aws}
                      style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={java}
                    style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-md-8 center">
              <div className="col-md-10">
                <div className="card">
                  <div className="card-header">
                    <span
                      className="iconify"
                      data-icon="emojione:red-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:yellow-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:green-circle"
                      data-inline="false"
                    ></span>
                  </div>
                  <div
                    className="card-body font-trebuchet text-justify ml-3 mr-3"
                    style={{
                      height: "auto",
                      fontSize: "132%",
                      lineHeight: "200%",
                    }}
                  >
                    <br />
                    <span className="wave">{hello} {' '}
                <span className='wave' role='img' aria-label='wave'>
                👋🏾
                </span>{' '}</span>
                    <br />
                    <br />
                    {paragraphs.map((para, i) => (
                        <p key={i} dangerouslySetInnerHTML={{__html: para}}/>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
